import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/products',
      component: () => import('@/components/Products.vue'),
      name: 'products',
      meta: { requiresAuth: true }
    },
    {
      path: '/categories',
      component: () => import('@/components/Categories.vue'),
      name: 'categories',
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      component: () => import('@/components/auth/Login.vue'),
      name: 'login'
    },
    {
      path: '/register',
      component: () => import('@/components/auth/Register.vue'),
      name: 'register'
    },
    {
      path: '/forgot',
      component: () => import('@/components/auth/ForgotPassword.vue'),
      name: 'forgot'
    },
    {
      path: '/newshop',
      component: () => import('@/components/CreateShop.vue'),
      name: 'newshop'
    },
    {
      path: '/shop',
      component: () => import('@/components/Shop.vue'),
      name: 'shop',
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      component: () => import('@/components/Orders.vue'),
      name: 'orders',
      meta: { requiresAuth: true }
    },
    {
      path: '/drivers',
      component: () => import('@/components/Drivers.vue'),
      name: 'drivers',
      meta: { requiresAuth: true }
    },
    {
      path: '/billing',
      component: () => import('@/components/Billing.vue'),
      name: 'billing',
      meta: { requiresAuth: true }
    },
    {
      path: '/report',
      component: () => import('@/components/Report.vue'),
      name: 'report',
      meta: { requiresAuth: true }
    },
    {
      path: '/customers',
      component: () => import('@/components/Customers.vue'),
      name: 'report',
      meta: { requiresAuth: true }
    },
    {
      path: '/terms',
      component: () => import('@/components/Terms.vue'),
      name: 'terms'
    }
  ]
})

export default router
